<template>
  <Dialog
    @submit="onSubmit"
    :title="showSpinner ? '' : title"
    :disableButtons="disableAll || !!showSpinner"
    :loading="loadingSaveBtn"
  >
    <div v-if="showSpinner" class="spinner-wrap">
      <spinner/>
    </div>
    <form
      v-else
      @submit.prevent="onSubmit"
    >
      <div class="container header-wrap">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-check">
              <label class="form-check-label">
                <input
                  type="checkbox"
                  :checked="isAllChecked"
                  :disabled="disableAll"
                  class="form-check-input"
                  @click="toggleAll"
                >
                <b>User Name</b>
              </label>
            </div>
          </div>
          <div class="col-sm-5">
            <b>User Email</b>
          </div>
          <div class="col-sm-3">
            <b>User Role</b>
          </div>
        </div>
      </div>
      <div class="container items">
        <label v-for="item of items" :key="item.id" class="form-check-label">
          <div class="row" >
            <div class="col-sm-4">
              <div class="form-check">
                <input
                  type="checkbox"
                  :value="+item.id"
                  :disabled="disableAll"
                  class="form-check-input"
                  v-model="checkedItems"
                />
                {{ item.name }}
              </div>
            </div>
            <div class="col-sm-5">
              {{ item.email }}
            </div>
            <div class="col-sm-3">
              {{ item.role }}
            </div>
          </div>
        </label>
      </div>
    </form>
  </Dialog>
</template>

<script>
import { uniq } from 'lodash';
import Dialog from '@/components/Dialog';
import Spinner from '@/components/Spinner';
import ModalMixin from '@/mixins/ModalMixin';

import CAMPAIGN from '@/graphql/Campaigns/Campaign.gql';
import ASSIGNABLE_USERS from '@/graphql/Users/AssignableUsers.gql';
import ASSIGNED_USERS from '@/graphql/Users/AssignedUsers.gql';
import ASSIGN_USERS from '@/graphql/Users/AssignUsers.gql';

export default {
  name: 'assign-component',
  mixins: [ModalMixin],
  components: {
    Dialog,
    Spinner,
  },
  props: {
    campaignId: Number,
    companyId: Number,
  },

  data() {
    return {
      items: [],
      checkedItems: [],
      campaign: {
        campaignName: '',
      },
      showSpinner: 0,
      disableAll: false,
      loadingSaveBtn: false,
    };
  },

  computed: {
    title() {
      const { campaignName } = this.campaign;
      return campaignName ? `Assign User to ${campaignName}` : '';
    },
    isAllChecked() {
      return this.checkedItems.length && this.checkedItems.length === this.items.length;
    },
  },

  methods: {
    onSubmit() {
      this.disableAll = true;
      this.loadingSaveBtn = true;

      this.$apollo
        .mutate({
          mutation: ASSIGN_USERS,
          variables: {
            campaignId: this.campaignId,
            userIds: this.checkedItems.map(uid => parseInt(uid)),
            users: this.items.map(({ id, email, role }) => ({
              id,
              email,
              role,
            })),
          },
        })
        .then(() => {
          this.close();

          this.$notify({
            group: 'success',
            type: 'success',
            text: 'Campaign was assigned',
          });
        })
        .catch(e => {
          this.$notify({
            group: 'error',
            type: 'error',
            text: e.message,
          });
        })
        .finally(() => {
          this.disableAll = false;
          this.loadingSaveBtn = false;
        });
    },

    toggleAll() {
      if (this.isAllChecked) {
        // uncheck
        this.checkedItems = [];
      } else {
        this.checkedItems = this.items.map(item => item.id);
      }
    },
  },

  apollo: {
    assignableUsers: {
      query: ASSIGNABLE_USERS,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      result({ data, loading }) {
        if (!loading) {
          this.items = data.assignableUsers;
        }
      },
      variables() {
        return { companyId: this.companyId };
      },
    },
    assignedUsers: {
      query: ASSIGNED_USERS,
      fetchPolicy: 'network-only',
      result({ data, loading }) {
        if (!loading) {
          this.checkedItems = uniq(data.assignedUsers.map(item => item.id));
        }
      },
      variables() {
        return {
          campaignId: this.campaignId,
        };
      },
    },
    campaign: {
      query: CAMPAIGN,
      fetchPolicy: 'network-only',
      loadingKey: 'showSpinner',
      result({ data, loading }) {
        if (!loading) {
          this.campaign = data.campaign;
        }
      },
      variables() {
        return {
          id: this.campaignId,
        };
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.header-wrap {
  margin-top: 10px;
}
.container.items {
  max-height: 314px;
  overflow: auto;
  .row {
    border-top: 1px solid #e9ecef;
    padding-top: 0.4rem;
  }
}
b {
  font-weight: 500;
}
label {
  font-weight: 300;
}
.form-check-label {
  width: 100%;
}
.spinner-wrap {
  position: relative;
  height: 100px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/modals/AssignUser.vue